/* Cart drawer telemetry
   ------------------------------------------------------------------
   WHY THIS IS A SEPARATE FILE, AND WHY IT EDITS NOTHING

   Shopify analytics says 5,134 sessions add to cart and 2,198 reach
   checkout. The other 2,936 leave no trace at all: close(), Escape, the
   backdrop and the back button are byte-identical from outside, so every
   explanation anyone offers for that gap is a guess. Five such guesses
   have already been disproved on this store. This counts the doors.

   It lives outside mini-cart.js on purpose. Not one line of the drawer's
   own handlers is touched, so the worst thing a bug in here can do is
   produce no data. It cannot stop an add to cart and it cannot stop a
   checkout. Reverting is deleting this file and one <script> tag.

   RULES THIS FILE KEEPS
   - Listeners only ever ADD. Nothing calls preventDefault or
     stopPropagation, nothing writes to the DOM, nothing wraps or replaces
     an existing handler.
   - Every listener body sits inside try/catch. gtag may be absent, stubbed
     by an app, or blocked by an extension; none of that may surface.
   - NO PERSONAL DATA. Ever. This cart carries engraving text - real
     people's names, often of someone who has died. Nothing derived from
     cart properties, product titles or the error message leaves the page.
     Counts, seconds and one rounded dollar figure, and that is all.
   - The answer is in the EVENT NAME, not in parameters. GA4 custom
     dimensions have to be registered before collection and never backfill,
     so a design that needs them loses its first days to a setup mistake.
     Event names need no setup and appear on their own under
     Reports > Engagement > Events. */

(function () {
  'use strict';

  var root = document.querySelector('.cart-drawer');
  if (!root) return;

  var BOUNCE_MS = 3000;         /* under this, treat the open as a mis-tap */
  var openedAt = 0;
  var isOpen = false;
  var reason = '';              /* set by the pointer/key listeners below */

  /* --- Transport -----------------------------------------------------------
     No send_to. Naming a target overrides routing, and if GA4 were only
     configured inside GTM rather than the main frame, every event would be
     silently dropped. Omitting it delivers to whatever is configured, which is
     verified working on this store.

     transport_type beacon so an event fired as the page goes away still
     leaves. That matters for exactly two events - the checkout tap and the
     back button - and those are the two the whole exercise depends on. */
  function track(name, params) {
    try {
      if (typeof window.gtag !== 'function') return;
      var p = params || {};
      p.transport_type = 'beacon';
      window.gtag('event', name, p);
    } catch (e) { /* telemetry must never surface */ }
  }

  /* Non-identifying only: how many lines, roughly how much, how long. */
  function snapshot() {
    var out = {};
    try {
      out.items = root.querySelectorAll('.cd-item').length;
      var sub = root.querySelector('[data-cd-subtotal]');
      if (sub) {
        var n = parseFloat(String(sub.textContent).replace(/[^0-9.]/g, ''));
        if (isFinite(n)) out.bag_usd = Math.round(n);
      }
    } catch (e) {}
    return out;
  }

  function onOpen() {
    openedAt = Date.now();
    isOpen = true;
    reason = '';
    track('km_bag_open', snapshot());
  }

  /* One call site for every way the bag can end, so a door can never be
     double-counted and dwell is always measured from the same clock. */
  function onExit(door) {
    if (!isOpen) return;
    isOpen = false;
    var dwell = Date.now() - openedAt;
    var p = snapshot();
    p.dwell_s = Math.round(dwell / 1000);
    track(door, p);
    /* Fired IN ADDITION to the door. A bag dismissed in under three seconds
       was not a decision, it was a thumb. Counting these separately is what
       stops a mis-tap being read as rejection. */
    if (dwell < BOUNCE_MS && door !== 'km_bag_checkout') track('km_bag_bounce', p);
  }

  /* --- Watch the drawer's own state ----------------------------------------
     Observing the class the drawer already sets means no hook into open() or
     close(), so this stays true even if their internals change. */
  try {
    new MutationObserver(function () {
      try {
        var nowOpen = root.classList.contains('is-open');
        if (nowOpen && !isOpen) onOpen();
        else if (!nowOpen && isOpen) onExit(reason || 'km_bag_close_other');
      } catch (e) {}
    }).observe(root, { attributes: true, attributeFilter: ['class'] });
  } catch (e) {}

  /* --- Attribute the exit --------------------------------------------------
     pointerdown, not click: it lands before navigation and before the class
     flips, so the reason is already set when the observer fires. Capture phase
     and passive - it observes the event, it never owns it. */
  try {
    document.addEventListener('pointerdown', function (e) {
      try {
        var t = e.target;
        if (!t || !t.closest) return;

        if (t.closest('[data-cd-checkout]')) {
          reason = 'km_bag_checkout';
          onExit('km_bag_checkout');       /* fire NOW: navigation is next */
          return;
        }
        if (t.closest('[data-cd-close]')) {
          /* The X and the backdrop share data-cd-close and are otherwise
             indistinguishable. The panel is min(94vw,440px), so on a 390px
             phone the backdrop is a 23px strip down the left edge - the iOS
             back-swipe gutter, and where a thumb rests while scrolling.
             Separating these two is the difference between "they declined"
             and "they fumbled". */
          reason = t.closest('.cart-drawer__panel')
            ? 'km_bag_close_x'
            : 'km_bag_close_backdrop';
          return;
        }
        if (isOpen && t.closest('.cart-drawer__panel') && t.closest('a[href]')) {
          /* Left via a product link inside the bag. Not an abandonment - they
             went to look at something - but it ends the bag session and is
             invisible today. */
          track('km_bag_link_out', snapshot());
        }
      } catch (err) {}
    }, { capture: true, passive: true });
  } catch (e) {}

  try {
    document.addEventListener('keydown', function (e) {
      try { if (e.key === 'Escape' && isOpen) reason = 'km_bag_close_escape'; } catch (err) {}
    }, { capture: true, passive: true });
  } catch (e) {}

  /* The bag now consumes Back rather than letting it exit the store, so a Back
     dismissal is a legitimate close - but counting it separately is the whole
     point: it measures how many people were reaching for that gesture, which is
     how we find out what the old behaviour was costing. */
  try {
    window.addEventListener('popstate', function () {
      try { if (isOpen) reason = 'km_bag_close_back'; } catch (e) {}
    });
  } catch (e) {}

  /* --- The back button -----------------------------------------------------
     pagehide catches the tab ending by any route, including Back. Whether
     Back closes the bag or leaves the store is a behaviour question settled
     separately in mini-cart.js; this only counts it. */
  try {
    window.addEventListener('pagehide', function () {
      try { if (isOpen) onExit('km_bag_leave_site'); } catch (e) {}
    });
  } catch (e) {}

  /* --- Did something break in front of them --------------------------------
     showError writes into this one node. Only the fact is reported, never the
     text: the message comes off the wire and can carry product and variant
     titles. */
  try {
    var errNode = root.querySelector('[data-cd-error]');
    if (errNode) {
      new MutationObserver(function () {
        try {
          if (String(errNode.textContent).trim()) track('km_bag_error', { items: snapshot().items });
        } catch (e) {}
      }).observe(errNode, { childList: true, subtree: true, characterData: true });
    }
  } catch (e) {}

  /* If the drawer was already open when this deferred script ran. */
  try { if (root.classList.contains('is-open')) onOpen(); } catch (e) {}
})();
